var Route;
(function (Route) {
    Route["Home"] = "/";
    Route["Login"] = "/";
    Route["VeoliaPrefix"] = "/veolia";
    Route["Admins"] = "/admins";
    Route["Clients"] = "/clients";
    Route["Profile"] = "/profile";
    Route["Companies"] = "/companies";
    Route["Users"] = "/users";
    Route["Calculations"] = "/calculations";
    Route["EditCalculation"] = "/edit-calculation/:calculationId";
    Route["DisplayCalculation"] = "/display-calculation/:calculationId";
    Route["Documents"] = "/documents";
    Route["CreateHistoricalModule"] = "/create-historical-module/:companyId";
    Route["DisplayHistoricalModule"] = "/display-historical-module/:companyId";
    Route["EditHistoricalModule"] = "/edit-historical-module/:companyId";
})(Route || (Route = {}));
export default Route;
